import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { getDesignPortfolios } from '../../../services/portfolio.service';

const apiUrl = process.env.REACT_APP_API_URL;

function DesignPortfolios() {

    const [designPortfolios, setDesignPortfolios] = useState();

    useEffect(() => {
        const fetchDesignPortfolios = () => {
            getDesignPortfolios().then((res) => {
                setDesignPortfolios((prev) => res.data)
            }).catch((err) => {
                console.log(Error);
            });
        }

        fetchDesignPortfolios();

    }, [])

    return (
        <div className='w-full min-h-screen bg-white dark:bg-dark-bg transition-colors duration-300'>
            <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                
                <div className="flex flex-col text-primary dark:text-white mb-12 items-center gap-4 pt-12">
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className='text-4xl font-bold text-center'
                    >
                        Design Portfolio
                    </motion.p>
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className='text-primary/70 dark:text-gray-400 text-center w-full lg:w-2/3 text-lg'
                    >
                        Explore our creative works, from branding and logo design to comprehensive UI/UX projects.
                    </motion.p>
                </div>

                <motion.div 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                >
                    {designPortfolios && designPortfolios.map((portfolio) => {
                        return (
                            <motion.div 
                                whileHover={{ y: -5 }}
                                key={portfolio.id} 
                                className='group bg-white dark:bg-dark-card text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden transition-all duration-300'
                            >
                                <div className="aspect-[4/3] w-full overflow-hidden bg-gray-200 dark:bg-gray-800 relative">
                                    {portfolio.images && portfolio.images.length>0 ? (
                                        <img src={`${apiUrl}${portfolio.images[0].image_url}`} alt=""
                                        className='h-full w-full object-cover object-center group-hover:scale-105 duration-300' />
                                    ) : (
                                        <div className="flex items-center justify-center h-full text-gray-400">No Image</div>
                                    )}
                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"/>
                                </div>
                                
                                <div className="p-5">
                                    <h3 className='font-bold text-lg mb-2'>{portfolio.title}</h3>
                                    <p className='text-gray-600 dark:text-gray-400 text-sm line-clamp-3'>{portfolio.description}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </div>
        </div>
    );
}

export default DesignPortfolios;